import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import Icon from '../components/Shared/Icon'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
    values: {
      'home': {
        component: Icon,
        props: {
          name: 'home',
          size: 20
        }
      },
      'menu': {
        component: Icon,
        props: {
          name: 'menu',
          size: 20
        }
      },
      'search': {
        component: Icon,
        props: {
          name: 'search',
          size: 20
        }
      },
      'star': {
        component: Icon,
        props: {
          name: 'star',
          size: 20
        }
      },
      'bell': {
        component: Icon,
        props: {
          name: 'bell',
          size: 29
        }
      },
      'user': {
        component: Icon,
        props: {
          name: 'user',
          size: 56
        }
      },
      'monitor': {
        component: Icon,
        props: {
          name: 'monitor',
          size: 56
        }
      },
      'users': {
        component: Icon,
        props: {
          name: 'users',
          size: 56
        }
      },
      'layers': {
        component: Icon,
        props: {
          name: 'layers',
          size: 56
        }
      },
      'refresh-ccw': {
        component: Icon,
        props: {
          name: 'refresh-ccw',
          size: 56
        }
      },
      'settings': {
        component: Icon,
        props: {
          name: 'settings',
          size: 56
        }
      },
      'clipboard': {
        component: Icon,
        props: {
          name: 'clipboard',
          size: 56
        }
      },
      'heart': {
        component: Icon,
        props: {
          name: 'heart',
          size: 56
        }
      },
      'inbox': {
        component: Icon,
        props: {
          name: 'inbox',
          size: 56
        }
      },
      'normal-bell': {
        component: Icon,
        props: {
          name: 'bell',
          size: 20
        }
      },
      'book': {
        component: Icon,
        props: {
          name: 'book',
          size: 20
        }
      },
      'userNormal': {
        component: Icon,
        props: {
          name: 'user',
          size: 20
        }
      },
      'monitorNormal': {
        component: Icon,
        props: {
          name: 'monitor',
          size: 20
        }
      },
      'usersNormal': {
        component: Icon,
        props: {
          name: 'users',
          size: 20
        }
      },
      'layersNormal': {
        component: Icon,
        props: {
          name: 'layers',
          size: 20
        }
      },
      'clipboardNormal': {
        component: Icon,
        props: {
          name: 'clipboard',
          size: 20
        }
      },
      'settingsNormal': {
        component: Icon,
        props: {
          name: 'settings',
          size: 20
        }
      },
      'refreshccwNormal': {
        component: Icon,
        props: {
          name: 'refresh-ccw',
          size: 20
        }
      },
      'inboxNormal': {
        component: Icon,
        props: {
          name: 'inbox',
          size: 20
        }
      },
      'heartNormal': {
        component: Icon,
        props: {
          name: 'heart',
          size: 20
        }
      },
      'chevron-down': {
        component: Icon,
        props: {
          name: 'chevron-down',
          size: 20
        }
      }
    }
  },
  theme: {
    themes: {
      light: {
        backgroundHome: '#F1F2F1',
        primary1: '#00995d',
        primary2: '#b1d34b',
        primary3: '#fff0c7',
        primary4: '#ffffff',
        grey1: '#60656c',
        grey2: '#9e9e9e',
        grey3: '#afafaf',
        grey4: '#cccccc',
        grey5: '#dee2e6',
        grey6: '#54585e',
        secondaryLight1: '#ed1651',
        secondaryLight2: '#a3238e',
        secondaryLight3: '#f47920',
        secondaryLight4: '#ffcb08',
        secondaryDark1: '#00401a',
        secondaryDark2: '#411564',
        secondaryDark3: '#0a5f55',
        secondaryDark4: '#682d00',
        fontColor: '#60656C',
        fontColor1: '#60656C',
        fontColor2: '#707070',
        warningUtil1: '#F0666F',
        warningUtil2: '#FFCB08',
        accent: '#8c9eff',
        error: '#ED1651'
      },
      dark: {
        backgroundHome: '#0E0D0E',
        primary1: '#00995d',
        primary2: '#b1d34b',
        primary3: '#fff0c7',
        primary4: '#000000',
        grey1: '#60656c',
        grey2: '#9e9e9e',
        grey3: '#afafaf',
        grey4: '#cccccc',
        grey5: '#dee2e6',
        grey6: '#54585e',
        secondaryLight1: '#ed1651',
        secondaryLight2: '#a3238e',
        secondaryLight3: '#f47920',
        secondaryLight4: '#ffcb08',
        secondaryDark1: '#00401a',
        secondaryDark2: '#411564',
        secondaryDark3: '#0a5f55',
        secondaryDark4: '#682d00',
        fontColor: '#60656C',
        fontColor1: '#60656C',
        fontColor2: '#707070',
        warningUtil1: '#F0666F',
        warningUtil2: '#FFCB08',
        accent: '#8c9eff',
        error: '#ED1651'
      }
    }
  }
})
